import { render, staticRenderFns } from "./产权需求详情_阶梯竞价版本.vue?vue&type=template&id=c35663ce&scoped=true"
import script from "./产权需求详情_阶梯竞价版本.vue?vue&type=script&lang=js"
export * from "./产权需求详情_阶梯竞价版本.vue?vue&type=script&lang=js"
import style0 from "./产权需求详情_阶梯竞价版本.vue?vue&type=style&index=0&id=c35663ce&prod&lang=css"
import style1 from "./产权需求详情_阶梯竞价版本.vue?vue&type=style&index=1&id=c35663ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35663ce",
  null
  
)

export default component.exports